import CreateAttachment from "./attachment/CreateAttachment.js";
import IconButton from "@material-ui/core/IconButton";
import ButtonMenu from "./ButtonMenu";
import ConfirmMessage from "./ConfirmationMessage.js";
import { Trans, withTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import Icon from "@material-ui/core/Icon";
import Snackbar from "@material-ui/core/Snackbar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import React, { Component } from "react";
import { addPortlet, deletePortlet } from "../redux/actions/menuActions";
import { deletePortletFromLayout } from "../redux/actions/layoutActions";
import CardHeader from "@material-ui/core/CardHeader";
import MaterialListItem from "@material-ui/core/ListItem";
import AddIcon from "@material-ui/icons/Add";
import Clear from "@material-ui/icons/Clear";
import Fullscreen from "@material-ui/icons/Fullscreen";
import FullscreenExit from "@material-ui/icons/FullscreenExit";
import CreatePortletDialog from "./dialog/CreatePortletDialog";
import Settings from "./settings/Settings";
import FilterListIcon from "@material-ui/icons/FilterList";
import "material-icons/iconfont/material-icons.css";
import Badge from "@material-ui/core/Badge";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Tree, { mutateTree } from "@atlaskit/tree";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Typography from "@material-ui/core/Typography";
import axios from "../AxiosClient";
import { Role, currentUserHasRole } from "../utils/RoleUtils";
import PubSub from "pubsub-js";
import Avatar from "@material-ui/core/Avatar";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import equal from "deep-equal";
import {
  PORTLET_LAYOUT_DELETE,
  MENU_PORTLET_ADD,
  PORTLET_ATTACHMENT_ADD,
  PORTLET_LAYOUT_UPDATE,
  USER_LIST_ADD,
} from "../utils/Topics";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import { withRouter } from "react-router";
import FilterWrapper from "./filter/FilterWrapper";
import IconPicker from "./IconPicker";
import Select from "@material-ui/core/Select";
import MaterialMenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

const styles = (theme) => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
  cardHeader: {
    position: "relative",
    "&:after": {
      position: "absolute",
      content: '""',
      borderBottom: `2px solid ${theme.palette.primary.main}`,
      width: "95%",
      transform: "translateX(-50%)",
      bottom: 0,
      left: "50%",
    },
  },
  cardContent: {
    flex: "1 0 10%",
  },
  cardActionWithoutFilter: {
    flex: "1 1",
  },
  cardActionResizing: {
    display: "none",
  },
  cardAction: {
    flex: "1 1 65%",
    flexDirection: "row",
    // width: "100%",
  },

  portletTitle: {
    fontSize: "1.15rem",
  },
  iconSelect: {
    marginRight: 30,
  },
  menuTitleInput: {
    paddingTop: 4,
    paddingBottom: 6,
  },
  spacer: {
    flexGrow: 1,
  },
});
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};

const DEFAULT_MENU_MAP = {
  document: 1004,
  search: 1007,
  content: 1002,
  entries: 1006,
  requiredreading: 1009,
  discussions: 1005,
};
export class ListHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canadd: true,
      deleteavailable: false,
      editlisttitle: false,
      attachmentClick: false,
      editClick: false,
      settingsClick: false,
      ownMenuPortlet: false,
      toast: false,
      toastMessage: "",
      settingsOpen: false,
      openedAddListToLayout: false,
      newCardTitle: "",
      openedAddToMenuDialog: false,
      openedDeleteFromMenuDialog: false,
      filterAnchorEl: null,
      filterElement: null,
      filterTitle: "",
      showFilters: false,
      haveFiltersChanged: false,
      filters: null,
      menuPortlet: { object: {} },
      adminAddToMenuOpen: false,
      menuTree: {},
      selectedParent: null,
      createUserListDialog: false,
      newListTitle: null,
      portletDescription: null,
      createExpertQuestionDialog: false,
      fullwidth: false,
      addForEveryone: false,
      iconPickerOpen: false,
      itemTitle: props.t(props.portlet.title),
      itemIcon: props.portlet.icon,
    };
    this.addPortletToLayout = this.addPortletToLayout.bind(this);
    this.changeNewPortletTitle = this.changeNewPortletTitle.bind(this);
    this.changeOpenedDeleteFromMenuDialog = this.changeOpenedDeleteFromMenuDialog.bind(
      this
    );
    this.saveToMenu = this.saveToMenu.bind(this);
    this.deleteMenuPortlet = this.deleteMenuPortlet.bind(this);
    this.openCreateAttachment = this.openCreateAttachment.bind(this);
    this.saveAttachment = this.saveAttachment.bind(this);
    this.openEditPortlet = this.openEditPortlet.bind(this);
    this.resetToDefaultFilters = this.resetToDefaultFilters.bind(this);
  }
  componentDidMount() {
    let filters = {};
    if (this.props.width > 3) {
      this.setState({ fullwidth: true });
    }
    try {
      if (this.props.filters) {
        filters = this.props.filters;
      } else {
        if (typeof this.props.portlet.parameters === "object") {
          filters = this.props.portlet.parameters;
        } else if (this.props.portlet.parameters) {
          filters = JSON.parse(this.props.portlet.parameters);
        }
      }
      if (this.props.portlet) {
        this.setState(
          {
            filters: filters,
          },
          () => {
            this.setFilterChange();
          }
        );
      }
    } catch (e) {}

    let filter = null;
    let selectedParent;
    // if (
    //   this.props.portlet.objectClass ===
    //   "com.kpsol.api.apicommon.search.SearcherInterface"
    // ) {
    //   filter = "FilterSearches";
    //   selectedParent = DEFAULT_MENU_MAP.search;
    // } else
    if (
      this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.document.DocumentInterface" ||
      this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface"
    ) {
      filter = "FilterDocuments";
      selectedParent = DEFAULT_MENU_MAP.document;
    } else if (
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.document.ReportInterface"
    ) {
      filter = "FilterReports";
    } else if (
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.discussions.EntryInterface"
    ) {
      filter = "FilterEntries";
      selectedParent = DEFAULT_MENU_MAP.entries;
    } else if (
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface"
    ) {
      filter = "FilterDiscussions";
      selectedParent = DEFAULT_MENU_MAP.discussions;
    } else if (
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.stats.MyStatsInterface"
    ) {
      filter = <div />;
    } else if (
      this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.history.SearchHistoryInterface" ||
      this.props.portlet.objectClass ===
        "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface"
    ) {
      filter = "FilterSearchHistory";
    } else if (
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.rework.ReworkInterface"
    ) {
      filter = "FilterRework";
    } else if (
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.list.ListUserListsInterface"
    ) {
      filter = "FilterLists";
    } 
    // else if (
    //   this.props.portlet.objectClass ===
    //   "com.kpsol.api.apicommon.list.UserListInterface"
    // ) {
    //   filter = "FilterUserList";
    // } 
    else if (
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.requiredreading.RequiredReadingInterface"
    ) {
      filter = "FilterRequiredReading";
      selectedParent = DEFAULT_MENU_MAP.requiredreading;
    } else if (
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.hottopic.HotTopicInterface"
    ) {
      filter = "FilterNotifications";
    } else if (
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.content.KnowledgeItemInterface"
    ) {
      filter = "FilterKnowledgeItems";
      selectedParent = DEFAULT_MENU_MAP.content;
    } else if (
      this.props.portlet.objectClass ===
      "com.kpsol.api.apicommon.expertquestion.ExpertQuestionInterface"
    ) {
      filter = "FilterExpertQuestion";
    }
    let filterTitle =
      this.props.t(this.props.portlet.title) +
      " " +
      this.props.t("global_filter");
    this.setState(
      {
        filterElement: filter,
        filterTitle: filterTitle,
        selectedParent: selectedParent,
      },
      () => {
        this.processTreeData();
      }
    );
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.width !== this.props.width) {
      this.setState({ fullwidth: this.props.width > 3 ? true : false });
    }
    var filterTitle =
      this.props.t(this.props.portlet.title) +
      " " +
      this.props.t("global_filter");
    if (this.state.filterTitle !== filterTitle) {
      this.setState({
        filterTitle: filterTitle,
      });
    }
    if (prevProps.portlet !== this.props.portlet) {
      if (!this.props.portlet.menuPortletId) {
        this.setFilterChange();
      }
      if (this.props.portlet.isUser === 1) {
        this.setState({
          ownMenuPortlet: true,
        });
      }
    }
    // i'm pretty sure we don't need this and it causes an infinite loop
    // for TextField based filters.. revisit if it is needed!
    // if (prevProps.portlet.parameters != this.props.portlet.parameters) {
    //   this.setState({ filters: JSON.parse(this.props.portlet.parameters) });
    // }

    let newFilters = {};

    if (this.props.menuDialog === true) {
      newFilters = this.props.filters;
    } else {
      try {
        newFilters = JSON.parse(this.props.portlet.parameters);
      } catch (e) {
        console.log("Warning: undefined portlet parameters.");
      }
    }

    if (
      prevProps.portlet.parameters != this.props.portlet.parameters &&
      !this.props.menuDialog
    ) {
      // if (newFilters.sort && newFilters.sort !== this.state.filters.sort) {
      //special case for when sort is set via table headers in fullscreen
      this.setState({ filters: newFilters });
      // }
    }
    if (this.state.filters) {
      if (
        (this.state.filters !== prevState.filters &&
          prevState.filters !== null) ||
        this.props.fullscreenPagination != prevProps.fullscreenPagination
      ) {
        if (!areObjectsEqual(this.state.filters, newFilters)) {
          this.updatePortlet();
        } else if (
          this.props.menuDialog === true &&
          this.state.filters !== null
        ) {
          // this.props.updateFilters(
          //   this.state.filters,
          //   this.haveFiltersChanged(),
          //   this.props.portlet.instance
          // );
        }
      }
    }
  }
  render() {
    const { classes, t } = this.props;
    return (
      <>
        <div
          style={{
            overflow: this.props.menuDialog && this.props.isMobile && "auto",
          }}
        >
          <div id="listcontent" className="listContent">
            {this.props.isportlet ? (
              <CardHeader
                classes={
                  (this.props.fullscreen || this.state.fullwidth)
                    ? {
                        root: classes.cardHeader,
                        action: this.props.resizing && this.props.resizing === true ? classes.cardActionResizing : classes.cardAction,
                        content: classes.cardContent,
                      }
                    : {
                        root: classes.cardHeader,
                        action: this.props.resizing && this.props.resizing === true ? classes.cardActionResizing : classes.cardActionWithoutFilter,
                        content: classes.cardContent,
                      }
                }
                className={classNames("handle", classes.cardHeader)}
                style={{
                  overflow: this.props.isMobile && "auto",
                }}
                avatar={
                  !(this.props.isMobile && this.props.menuDialog) && (
                    <Avatar aria-label="portlet" className={classes.avatar}>
                      <span className="material-icons">
                        {this.props.portlet.icon}
                      </span>
                    </Avatar>
                  )
                }
                action={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                    {(this.props.fullscreen ||
                      this.props.menuDialog ||
                      this.state.fullwidth) ? (

                        <FilterWrapper
                          noTaxonomy={
                            this.props.portlet.objectClass ===
                            "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface" ||
                            this.props.noTaxonomy
                          }
                          menuDialog={this.props.menuDialog}
                          asPopper={false}
                          open={true}
                          onClose={this.closeFilters}
                          anchorEl={this.state.filterAnchorEl}
                          filterElement={this.state.filterElement}
                          filter={
                            this.props.menuDialog === true ||
                              (this.props.portalLayout.layoutType === "team" &&
                              this.props.teamLayoutEditMode === false)
                                ? this.state.filters
                                : this.props.filters
                          }
                          onFilterChange={this.onFilterChange}
                          setTaxonomyTest={this.props.setTaxonomy}
                          isFilterBar={false}
                          title={this.state.filterTitle}
                          showReset={this.state.haveFiltersChanged}
                          resetToDefaultFilters={this.resetToDefaultFilters}
                          filterInstance={this.state.filterInstance}
                          objectClass={this.props.portlet.objectClass}
                          returnTaxonomyControl={
                            this.props.returnTaxonomyControl
                          }
                        />

                    ) : (
                      <div className={classes.spacer}></div>
                    )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginLeft: "auto",
                        alignItems: "center",
                      }}
                    >
                      {this.props.portlet.objectClass ===
                        "com.kpsol.api.apicommon.list.ListUserListsInterface" && (
                        <Tooltip
                          title={
                            <Typography>
                              {t("create_new_user_list_header")}
                            </Typography>
                          }
                        >
                          <IconButton onClick={this.openCreateUserList}>
                            <AddIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                      {currentUserHasRole(Role.ASK_EXPERT) &&
                        !this.props.isMobile &&
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.expertquestion.ExpertQuestionInterface" && (
                          <Tooltip
                            title={
                              <Typography>
                                {t("create_expert_question")}
                              </Typography>
                            }
                          >
                            <IconButton onClick={this.openCreateExpertQuestion}>
                              <AddIcon />
                            </IconButton>
                          </Tooltip>
                        )}
                      {(this.props.portlet.objectClass ===
                        "com.kpsol.api.apicommon.document.DocumentInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.document.ReportInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.discussions.EntryInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.discussions.DiscussionIndexInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.history.SearchHistoryInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.history.SearchHistoryAnalyticsInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.list.ListUserListsInterface" ||
                        // this.props.portlet.objectClass ===
                        //   "com.kpsol.api.apicommon.list.UserListInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.content.KnowledgeItemInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.rework.ReworkInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.requiredreading.RequiredReadingInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.hottopic.HotTopicInterface" ||
                        this.props.portlet.objectClass ===
                          "com.kpsol.api.apicommon.expertquestion.ExpertQuestionInterface") && (
                        <>
                          {!this.props.fullscreen &&
                            !this.props.menuDialog &&
                            !this.state.fullwidth && (
                              <Tooltip
                                title={
                                  <Typography>
                                    {this.state.haveFiltersChanged
                                      ? this.props.t("portlet_filters_modified")
                                      : this.props.t("global_filter")}
                                  </Typography>
                                }
                              >
                                <IconButton
                                  onClick={
                                    !this.props.isMobile && this.toggleFilters
                                  }
                                  onPointerDown={
                                    this.props.isMobile && this.toggleFilters
                                  }
                                >
                                  <Badge
                                    color="secondary"
                                    variant="dot"
                                    invisible={!this.state.haveFiltersChanged}
                                  >
                                    <FilterListIcon />
                                  </Badge>
                                </IconButton>
                              </Tooltip>
                            )}
                        </>
                      )}
                      {!this.props.menuDialog &&
                        !this.props.isMobile && (
                          <Tooltip
                            title={
                              <Typography>
                                {this.props.t("global_fullscreen")}
                              </Typography>
                            }
                          >
                            <IconButton onClick={this.props.toggleFullscreen}>
                              {!this.props.fullscreen ? (
                                <Fullscreen />
                              ) : (
                                <FullscreenExit />
                              )}
                            </IconButton>
                          </Tooltip>
                        )}
                      {!this.props.menuDialog && 
                        (this.props.portalLayout.layoutType === "user" ||
                          (this.props.portalLayout.layoutType === "team" &&
                            currentUserHasRole(Role.TEAM_LEADER) &&
                            this.props.teamLayoutEditMode === true)) &&
                      (
                        <ButtonMenu
                          ariaLabel={`${this.props.portlet.title} options`}
                        >
                          <MenuItem onClick={this.openCreateAttachment}>
                            <Trans i18nKey="list_header_add_attachment" />
                          </MenuItem>
                          {this.checkIfUserCanEditPortlet() && (
                            <MenuItem onClick={this.openEditPortlet}>
                              <Trans i18nKey="list_header_edit_portlet" />
                            </MenuItem>
                          )}
                          {/* {this.props.portlet.objectClass ===
                            "com.kpsol.api.apicommon.list.UserListInterface" && (
                            <MenuItem onClick={this.openAllDocumentsInNewTabs}>
                              Open all documents in new tabs
                            </MenuItem>
                          )} */}
                          <MenuItem onClick={this.changeOpenedAddToMenuDialog}>
                            <Trans i18nKey="list_header_save_to_menu" />
                          </MenuItem>
                          {currentUserHasRole(Role.ADMINISTRATOR) && (
                            <MenuItem onClick={this.openAdminAddToMenu}>
                              <Trans i18nKey="list_header_save_to_menu_admin" />
                            </MenuItem>
                          )}
                          {(this.props.portlet.objectClass !==
                            "com.kpsol.api.apicommon.hottopic.HotTopicInterface" && 
                            this.props.portlet.objectClass !== "com.kpsol.api.apicommon.stats.MyStatsInterface") && (
                            <MenuItem onClick={this.changeSettingsOpen}>
                              <Trans i18nKey="list_header_type_settings" />
                            </MenuItem>
                          )}
                        </ButtonMenu>
                      )}
                      {!this.props.fullscreen && (
                        <>
                          {(!this.props.menuDialog &&
                            (this.props.portalLayout.layoutType === "user" ||
                              (currentUserHasRole(Role.TEAM_LEADER) &&
                                this.props.portalLayout.layoutType === "team" &&
                                this.props.teamLayoutEditMode === true))) && (
                            <Tooltip
                              title={
                                <Typography>
                                  {this.props.t(
                                    "list_header_delete_from_layout"
                                  )}
                                </Typography>
                              }
                            >
                              <IconButton
                                aria-label={"delete-from-layout"}
                                onClick={
                                  !this.props.isMobile && this.deletePortlet
                                }
                                onMouseEnter={() => console.log("mouse over!")}
                                OnTouchStart={this.deletePortlet}
                                onPointerDown={
                                  this.props.isMobile && this.deletePortlet
                                }
                                style={{ cursor: "pointer" }}
                              >
                                <Clear />
                              </IconButton>
                            </Tooltip>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                }
                title={
                  !(this.props.isMobile && this.props.menuDialog) && (
                    <Typography
                      variant="h6"
                      component="h3"
                      className={classes.portletTitle}
                    >
                      {this.props.t(this.props.portlet.title)}
                    </Typography>
                  )
                }
                subheader={
                  !(this.props.isMobile && this.props.menuDialog) &&
                  this.props.t(this.props.portlet.portletDescription)
                }
              />
            ) : null}

            {!this.props.isportlet ? (
              <MaterialListItem className="menu" style={{ cursor: "pointer" }}>
                <ListItemIcon>
                  <Icon>{this.props.portlet.icon}</Icon>
                </ListItemIcon>
                <ListItemText
                  primary={this.props.t(this.props.portlet.title)}
                />
                {this.state.canadd ? (
                  <IconButton
                    icon="add"
                    color="red"
                    onClick={this.addPortletToLayout}
                    style={{ padding: 0 }}
                  >
                    <AddIcon />
                  </IconButton>
                ) : null}
                {this.props.portlet.isUser ? (
                  <IconButton onClick={this.changeOpenedDeleteFromMenuDialog}>
                    <Clear />{" "}
                  </IconButton>
                ) : null}
              </MaterialListItem>
            ) : null}
          </div>
          <Dialog
            fullWidth
            maxWidth="lg"
            open={this.state.attachmentClick}
            aria-labelledby="api-dialog-title"
            aria-describedby="api-dialog-description"
            disableEnforceFocus={true}
          >
            {this.state.attachmentClick ? (
              <CreateAttachment
                close={this.openCreateAttachment}
                onSaveAttachment={this.saveAttachment}
                id="createattachment"
                style={{ padding: 0 }}
              />
            ) : (
              <div />
            )}
          </Dialog>
          {this.state.editClick && (
            <CreatePortletDialog
              instance={this.props.portlet.instance}
              layoutId={this.props.portalLayout.layoutId}
              handleSubmit={this._editPortlet}
              onClose={this.openEditPortlet}
              open={this.state.editClick}
              portlet={this.props.portlet}
              addPortlet={false}
            />
          )}
          <ConfirmMessage
            text="You are about to add this portlet to your menu?"
            onConfirm={this.saveToMenu}
            openDialog={this.state.openedAddToMenuDialog}
            changeOpened={this.changeOpenedAddToMenuDialog}
          />
          <ConfirmMessage
            text="You are about to delete this portlet from your menu forever?"
            onConfirm={this.deleteMenuPortlet}
            openDialog={this.state.openedDeleteFromMenuDialog}
            changeOpened={this.changeOpenedDeleteFromMenuDialog}
          />
          <Dialog
            // fullWidth={true}
            maxWidth={"lg"}
            open={this.state.settingsOpen}
            aria-labelledby="api-dialog-title"
            aria-describedby="api-dialog-description"
          >
            {!this.props.settingsOpen ? (
              <Settings
                portlet={this.props.portlet}
                close={this.changeSettingsOpen}
              />
            ) : null}
          </Dialog>
          <Dialog
            open={this.state.adminAddToMenuOpen}
            aria-labelledby="admin-add-dialog-title"
            aria-describedby="admin-add-dialog-description"
          >
            <DialogTitle>
              <Trans i18nKey="admin_add_portlet_to_menu_header" />
            </DialogTitle>
            <DialogContent>
              <Typography style={{ marginBottom: 20 }}>
                <Trans i18nKey="admin_add_portlet_to_menu_body" />
              </Typography>
              <div>
                <Tree
                  tree={this.state.menuTree}
                  renderItem={this.renderTreeItem}
                  isDragEnabled={false}
                  onExpand={this.onTreeExpand}
                  onCollapse={this.onTreeCollapse}
                />
              </div>
              <div style={{ display: "block" }}>
                <div style={{ display: "flex" }}>
                  <Typography style={{ marginBottom: 20, marginTop: 20 }}>
                    {"Chose an icon and a title for the menu item"}
                  </Typography>
                </div>
                <div style={{ display: "flex" }}>
                  <FormControl className={this.props.classes.iconSelect}>
                    <InputLabel htmlFor="icon">Icon</InputLabel>
                    <Select
                      open={false}
                      value="icon"
                      onOpen={this.openIconPicker}
                      inputProps={{
                        name: "icon",
                        id: "icon",
                      }}
                    >
                      <MaterialMenuItem value="icon">
                        <span className="material-icons">
                          {this.state.itemIcon}
                        </span>
                      </MaterialMenuItem>
                    </Select>
                  </FormControl>
                  <IconPicker
                    open={this.state.iconPickerOpen}
                    onPick={this.changeItemIcon}
                    handleClose={this.closeIconPicker}
                  />
                  <FormControl>
                    <TextField
                      fullWidth
                      required
                      label={this.props.t("link_title")}
                      value={this.state.itemTitle}
                      onChange={this.handleItemTitleChange}
                      InputProps={{
                        className: this.props.classes.menuTitleInput,
                      }}
                    />
                  </FormControl>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.cancelAdminAddMenu}>
                <Trans i18nKey="global_cancel" />
              </Button>
              <Button onClick={this.adminAddToMenu}>
                <Trans i18nKey="global_add" />
              </Button>
            </DialogActions>
          </Dialog>
          <Snackbar
            id="menuMessage"
            className="fit-bottom"
            onClose={this._closeToast}
            open={this.state.toast}
            message={this.state.toastMessage}
          />

          <Dialog
            open={this.state.createUserListDialog}
            onClose={this.openCreateUserList}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <Trans i18nKey="create_new_user_list_header" />
            </DialogTitle>
            <DialogContent>
              <TextField
                id="standard-name"
                label="List title"
                value={this.state.newListTitle}
                onChange={this.updateNewListTitle}
                margin="normal"
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={this.openCreateUserList} color="primary">
                <Trans i18nKey="global_cancel" />
              </Button>
              <Button
                onClick={this.handleNewListDialogSubmit}
                color="primary"
                autoFocus
              >
                <Trans i18nKey="global_submit" />
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </>
    );
  }

  checkIfUserCanEditPortlet = () => {
    if (
      this.props.currentUser.userType != "limited" &&
      this.props.portalLayout.layoutType != "team"
    ) {
      return true;
    } else if (
      this.props.portalLayout.layoutType === "team" &&
      currentUserHasRole(Role.TEAM_LEADER)
    ) {
      return true;
    } else {
      return false;
    }
  };

  getTreeIcon = (item, onExpand, onCollapse) => {
    return item.isExpanded ? (
      <IconButton style={{ padding: 0 }} onClick={() => onCollapse(item.id)}>
        <ExpandLessIcon />
      </IconButton>
    ) : (
      <IconButton style={{ padding: 0 }} onClick={() => onExpand(item.id)}>
        <ExpandMoreIcon />
      </IconButton>
    );
  };

  renderTreeItem = ({ item, provided, onExpand, onCollapse }) => {
    if (item.children.length === 0) {
      return (
        <div
          style={{ display: "none" }}
          ref={provided.innerRef}
          {...provided.draggableProps}
        />
      );
    }
    return (
      <div ref={provided.innerRef} {...provided.draggableProps}>
        <span>{this.getTreeIcon(item, onExpand, onCollapse)}</span>
        <span
          style={{
            cursor: "pointer",
            backgroundColor: item.data.selected ? "#ccc" : "",
            padding: 5,
          }}
          onClick={() => this.selectParent(item)}
        >
          {item.data.title}
        </span>
      </div>
    );
  };

  selectParent = (item) => {
    if (item.data.selected) {
      this.setState({
        menuTree: mutateTree(this.state.menuTree, item.id, {
          data: { selected: false, title: item.data.title },
        }),
      });
    } else {
      let tree = { ...this.state.menuTree };
      // reset selected on all items
      Object.keys(tree.items).forEach((key) => {
        if (key === item.id) {
          tree = mutateTree(tree, key, {
            data: { selected: true, title: tree.items[key].data.title },
          });
          this.setState({ selectedParent: item.id });
        } else {
          tree = mutateTree(tree, key, {
            data: { selected: false, title: tree.items[key].data.title },
          });
        }
      });
      this.setState({ menuTree: tree });
    }
  };

  setFilterChange = () => {
    this.setState({
      haveFiltersChanged: this.haveFiltersChanged(),
    });
  };

  getNonNullFilterValues = (filter) => {
    return Object.entries(filter)
      .reduce((a,[k,v]) => 
        ((v == null || 
          (typeof v === "string" && !v) ||
          (typeof v === "string" && v.toLowerCase() === "all") ||
          (typeof v === "string" && v.toLowerCase() === "any") ||
          (Array.isArray(v) && v.length === 0))
          ? a : (a[k]=v, a)), {}
        )
  }

  haveFiltersChanged = () => {
    if (
      this.props.portlet.originalMenuPortlet ||
      this.props.menuDialog === true
    ) {
      try {
        let menuFilters =
          !this.props.portlet.originalMenuPortlet.hasOwnProperty("parameters") ||
          this.props.portlet.originalMenuPortlet.parameters === null
          ? {}
          : typeof this.props.portlet.originalMenuPortlet.parameters === "object"
            ? this.props.portlet.originalMenuPortlet.parameters
            : {
                ...JSON.parse(
                  this.props.portlet.originalMenuPortlet.parameters
                ),
              }
        //when using TaxonomyDocumentInterface a from a menuDialog (fullscreen menu option) we want to ignore changes to the taxonomy filter if it is set
        this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface" &&
          delete menuFilters.taxonomy;
        // let currentFilters = {...JSON.parse(this.props.portlet.parameters)}
        let currentFilters = Object.assign({}, { ...this.state.filters });
        this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface" &&
          delete currentFilters.taxonomy;
        this.props.menuDialog === true && delete currentFilters.page;
        this.props.menuDialog === true && delete currentFilters.size;
        this.props.menuDialog === true &&
          delete currentFilters.taxonomySelection;
        // this.props.menuDialog === true && delete currentFilters.taxonomyDialogOpen

        //menu filters for taxonomy can be missing and if so are wrongly compared
        if (
          menuFilters &&
          currentFilters &&
          !menuFilters.hasOwnProperty("taxonomy") &&
          currentFilters.hasOwnProperty("taxonomy") &&
          this.props.portlet.objectClass !==
            "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface"
        ) {
          menuFilters.taxonomy = [];
        }
        let currentNonNull = this.getNonNullFilterValues(currentFilters)
        let menuNonNull = this.getNonNullFilterValues(menuFilters)
        if (!areObjectsEqual(currentNonNull, menuNonNull)) {
          //page and size are missing from the menu params for Document based ones
          return true;
        }
      } catch (x) {
        alert(x);
      }
    }
    return false;
  };

  resetToDefaultFilters = () => {
    if (
      this.props.portlet.originalMenuPortlet 
    ) {
      
      let resetFilters = 
        this.props.portlet.originalMenuPortlet.hasOwnProperty("parameters") || 
        this.props.portlet.originalMenuPortlet.parameters === null
          ? JSON.parse(
            this.props.portlet.originalMenuPortlet.parameters
          )
          :
          {}
      //if noTaxonomy is set the current taxonomy state back onto the filters
      if (
        this.props.portlet.objectClass ===
          "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface" &&
        this.state.filters.taxonomy
      ) {
        resetFilters.taxonomy = this.state.filters.taxonomy;
      }
      this.setState({
        filters: resetFilters,
      });
    }
  };

  onFilterChange = (filter) => {
    let cloned = { ...filter };
    this.setState({
      filters: cloned,
    });
  };
  changeOpenedDeleteFromMenuDialog = () => {
    this.setState({
      openedDeleteFromMenuDialog: !this.state.openedDeleteFromMenuDialog,
    });
  };
  changeOpenedAddToMenuDialog = () => {
    this.setState({ adminAddToMenuOpen: true });

    // this.setState({ openedAddToMenuDialog: !this.state.openedAddToMenuDialog });
  };
  changeNewPortletTitle = (e) => {
    this.setState({ newCardTitle: e.target.value });
  };

  toggleFilters = (e) => {
    this.props.toggleFilters(
      e.currentTarget,
      this.state.filterElement,
      this.state.filters,
      this.onFilterChange,
      this.state.filterTitle,
      this.state.haveFiltersChanged,
      this.resetToDefaultFilters,
      this.props.portlet.instance,
      this.props.portlet.objectClass
    );
  };
  openCreateAttachment = () => {
    this.setState({ attachmentClick: !this.state.attachmentClick });
  };
  openAllDocumentsInNewTabs = () => {
    var isChromium = !!window.chrome;
    console.log(isChromium);
    // let prevWindow;
    // let test = this.openTab;
    // let index = 1;
    // this.props.data.forEach((item) => {
    //   if (item.type === "document") {
    //     prevWindow = test(`/full/document/${item.id}`, prevWindow, index);
    //     index++;
    //   }
    // });
  };

  openTab = (url, prevWindow, index) => {
    if (prevWindow) {
      let newWindow;
      newWindow = prevWindow.open(url, index);
      return newWindow;
    } else {
      let newWindow = window.open(url, index);
      return newWindow;
    }
  };
  openEditPortlet = () => {
    this.setState({ editClick: !this.state.editClick });
  };
  changeSettingsOpen = () => {
    this.setState({ settingsOpen: !this.state.settingsOpen });
  };
  _closeToast = () => {
    this.setState({
      toast: false,
    });
  };

  deleteMenuPortlet = () => {
    axios
      .delete(`/menuportlet/${this.props.portlet.id}`)
      .then(() => this.deleteMenuPortletResponse());
    this.changeOpenedDeleteFromMenuDialog();
  };
  addPortletToLayout = (e) => {
    let portlet = Object.assign({}, this.props.portlet);
    portlet.isportlet = true;
    portlet.fullscreen = false;
    portlet.menuPortletId = this.props.portlet.id;
    portlet.id = null;
    portlet.instance = new Date().getTime();
    axios.post(`/portalLayout/${this.props.portalLayout.layoutId}/portlet/`, {
      ...portlet,
    });
    this.setState({ openedAddListToLayout: !this.state.openedAddListToLayout });
  };

  cancelAdminAddMenu = () => {
    this.setState({ adminAddToMenuOpen: false });
  };

  openAdminAddToMenu = () => {
    this.setState({ adminAddToMenuOpen: true, addForEveryone: true });
  };

  adminAddToMenu = () => {
    let addForEveryone = this.state.addForEveryone;
    this.setState({ adminAddToMenuOpen: false, addForEveryone: false });
    axios
      .post("/menuportlet/", {
        ...this.props.portlet,
        title: this.state.itemTitle,
        icon: this.state.itemIcon,
        parentId: this.state.selectedParent,
        requiredRoles: [1],
        isUser: addForEveryone ? 0 : 1,
      })
      .then((res) => {
        PubSub.publish(MENU_PORTLET_ADD, { portlet: res.data });
      });
  };

  processTreeData = () => {
    let tree = {
      rootId: "root",
      items: {
        root: {
          id: "root",
          children: ["0"],
          hasChildren: true,
          isExpanded: true,
          data: {},
        },
        "0": {
          id: "0",
          children: [],
          hasChildren: true,
          isExpanded: true,
          data: {
            title: this.props.t("admin_add_portlet_to_menu_root_label"),
            selected: !this.state.selectedParent,
          },
        },
      },
    };
    tree = this.processChildren(tree, this.props.menu, "0");
    this.setState({ menuTree: tree });
  };

  processChildren = (origTree, elements, parentId) => {
    let tree = JSON.parse(JSON.stringify(origTree));
    elements.forEach((ele) => {
      let newItem = {
        id: ele.id.toString(),
        hasChildren: true,
        isExpanded: parentId === "0",
        data: {
          title: this.props.t(ele.title),
          selected: this.state.selectedParent === ele.id,
        },
        children: ele.children.map((child) => child.id.toString()),
      };
      tree.items[ele.id] = newItem;
      if (parentId === "0") {
        tree.items[parentId].children.push(ele.id.toString());
      }
      tree = this.processChildren(tree, ele.children, ele.id.toString());
    });
    return tree;
  };

  onTreeExpand = (itemId) => {
    this.setState({
      menuTree: mutateTree(this.state.menuTree, itemId, { isExpanded: true }),
    });
  };

  onTreeCollapse = (itemId) => {
    this.setState({
      menuTree: mutateTree(this.state.menuTree, itemId, { isExpanded: false }),
    });
  };

  updatePortlet() {
    let portlet = JSON.parse(JSON.stringify(this.props.portlet));
    let tempFilters = this.state.filters;
    tempFilters.taxonomy &&
      tempFilters.taxonomy.map((tax) => {
        tax.taxArray = [];
      });
    portlet.parameters = JSON.stringify(tempFilters);
    portlet.parametersString = JSON.stringify(tempFilters);
    if (this.props.fullscreenPagination != null) {
      portlet.fullscreenPagination = JSON.stringify(
        this.props.fullscreenPagination
      );
    }
    let haveFiltersChanged = this.haveFiltersChanged();
    this.setState({ haveFiltersChanged: haveFiltersChanged });
    this.state.filters !== null &&
      this.props.updateFilters(
        this.state.filters,
        haveFiltersChanged,
        this.props.portlet.instance
      );
    if (this.props.portalLayout.layoutType === "team"  &&
        this.props.teamLayoutEditMode === false) {
      PubSub.publish(PORTLET_LAYOUT_UPDATE, { portlet: portlet });
      return;
    }
    if ((portlet.portalLayoutID) &&
        (this.props.portalLayout.layoutType === "user" ||
          (this.props.portalLayout.layoutType === "team" &&
            this.props.teamLayoutEditMode === true &&
            currentUserHasRole(Role.TEAM_LEADER)))) {
      axios
        .patch(
          `/portalLayout/${this.props.portlet.portalLayoutID}/portlet/${
            this.props.portlet.id
          }`,
          {
            ...portlet,
          }
        )
        .then((res) => {
          PubSub.publish(PORTLET_LAYOUT_UPDATE, { portlet: res.data });
        });
    } 
  }

  saveToMenu = () => {
    this.setState({ openedAddToMenuDialog: !this.state.openedAddToMenuDialog });
    let menuPortlet = { ...this.props.portlet };
    menuPortlet.title = this.state.itemTitle;
    menuPortlet.icon = this.state.itemIcon;
    menuPortlet.isUser = 1;
    menuPortlet.requiredRoles = [1];
    axios
      .post("/menuportlet/", {
        ...menuPortlet,
      })
      .then((res) => {
        PubSub.publish(MENU_PORTLET_ADD, { portlet: res.data });
      });
  };
  getMenuOptions = () => {
    var universal = document.querySelector("universal-element");
    universal.getMenuOptions();
  };
  saveAttachment = (e, attachments) => {
    let attachment = {};
    let attachmentValues = Object.assign({}, e);
    attachment.portletID = this.props.portlet.id;
    attachment.text = attachmentValues.text;
    attachment.top = attachmentValues.top;
    attachment.attachmentIds = attachments;
    this.setState({ attachmentClick: !this.state.attachmentClick });
    axios
      .post(
        `/portalLayout/${this.props.portalLayout.id}/portlet/${
          this.props.portlet.id
        }/portletattachment/`,
        {
          ...attachment,
        }
      )
      .then((res) => {
        PubSub.publish(PORTLET_ATTACHMENT_ADD, {
          portletId: this.props.portlet.id,
          attachment: res.data,
        });
      });
  };
  deletePortlet = (evt) => {
    axios
      .delete(
        `/portalLayout/${this.props.portlet.portalLayoutID}/portlet/${
          this.props.portlet.id
        }`
      )
      .then((res) => {
        PubSub.publish(PORTLET_LAYOUT_DELETE, {
          layoutId: this.props.portalLayout.id,
          portletId: this.props.portlet.id,
        });
      });
  };

  _editPortlet = (e) => {
    this.dispatchEvent(
      new CustomEvent("edit-portlet", {
        detail: e.detail,
        bubbles: true,
        composed: true,
      })
    );
  };

  deleteMenuPortletResponse = () => {
    this.props.deletePortlet(this.props.portlet);
    this.setState({
      toast: true,
      toastMessage: "Portlet deleted from the menu",
    });
  };

  openCreateUserList = () => {
    this.setState({
      createUserListDialog: this.state.createUserListDialog ? false : true,
    });
  };

  openCreateExpertQuestion = () => {
    // this.setState({
    //   createExpertQuestionDialog: this.state.createExpertQuestionDialog ? false : true
    // });
    this.props.history.push("/full/createexpertquestion");
  };

  handleNewListDialogSubmit = () => {
    axios
      .post("/userlist/", {
        title: this.state.newListTitle,
        items: JSON.stringify([]),
      })
      .then((res) => {
        this.openCreateUserList();
        PubSub.publish(USER_LIST_ADD, {});
      });
  };

  updateNewListTitle = (e) => {
    this.setState({ newListTitle: e.target.value });
  };

  handleItemTitleChange = (e) => {
    this.setState({ itemTitle: e.target.value });
  };

  openIconPicker = () => {
    this.setState({ iconPickerOpen: true });
  };

  changeItemIcon = (e) => {
    this.setState({ itemIcon: e });
  };

  closeIconPicker = () => {
    this.setState({ iconPickerOpen: false });
  };
}
const mapStateToProps = (state) => ({
  edit: state.layout.edit,
  portalLayout: state.layout.currentLayout,
  currentUser: state.user.currentUser,
  menu: state.menu.firstMenu,
  isMobile: state.screen.isMobile,
  teamLayoutEditMode: state.layout.teamLayoutEditMode,
});
const mapDispatchToProps = {
  addPortlet,
  deletePortlet,
  deletePortletFromLayout,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(withTranslation()(ListHeader)))
);
